import { Box, Stack } from "@chakra-ui/react";
import { getCdnImageSrc, Image, VStack, responsive, colors } from "goi_common";
import { ReactNode } from "react";

export default function DisposalBenefitSection() {
  return (
    <VStack width="100%" alignItems="center" background={colors.gray900}>
      <VStack
        maxWidth={`${1200}px`}
        gap="28px"
        css={responsive({
          padding: {
            base: "64px 24px",
            lg: "120px 24px",
          },
        })}
      >
        <VStack
          width="100%"
          css={responsive({
            alignItems: { base: "center", lg: "flex-start" },
            marginBottom: "40px",
          })}
          gap="16px"
        >
          <Box
            className="white head_28_b lg_head_42_b"
            css={responsive({ textAlign: { base: "center", lg: "left" } })}
          >
            전국 당일배송,
            <br className="lg_over_hidden" /> 높은 퀄리티 용품, 확실한 물품 관리
          </Box>
          <Box
            className="gray300 subtitle_16_m lg_head_24_r"
            css={responsive({ textAlign: { base: "center", lg: "left" } })}
          >
            전국 당일배송, 편리한 발주, 철저한 용품관리, 고객사 중심의 정산까지
            <br />
            운영에 필요한 것들 모두 높은 퀄리티로 보장합니다.
          </Box>
        </VStack>
        <BenefitItem
          num={1}
          title={"전국 당일배송이 가능해요"}
          description={
            <>
              급작스럽게 발생한 임직원 장례, <br />
              전국 어디든 당일배송이 가능합니다.
            </>
          }
          imageSize={{
            width: { base: "100%", lg: "35%" },
            height: { base: "100%", lg: "600px" },
          }}
          justifyContent="flex-start"
        />
        <BenefitItem
          num={2}
          title={"카톡 한 번으로 발주 끝"}
          description={
            <>
              카톡이나 전화로 발주하면, 배송현황을 카톡으로 보내드려요.
              <br />
              도착유무를 매번 전화할 필요 없어요.
            </>
          }
          imageSize={{
            width: { base: "100%", lg: "42%" },
            height: { base: "100%", lg: "240px" },
          }}
        />
        <BenefitItem
          num={3}
          title={"제품 변질률 0%, 문제 발생시 100% 환불"}
          description={
            <>
              제작 후 2년동안 제품 변질률 0%였어요.
              <br />
              확실하게 재고관리로 제품 변질을 걱정하지 마세요.
            </>
          }
          imageSize={{
            width: { base: "100%", lg: "40%" },
            height: { base: "100%", lg: "240px" },
          }}
        />
      </VStack>
    </VStack>
  );
}

function BenefitItem({
  num,
  title,
  imageSize,
  description,
  justifyContent,
}: {
  num: number;
  title: string;
  imageSize: {
    width: { base: string; lg: string };
    height: { base: string; lg: string };
  };
  description: ReactNode;
  justifyContent?: string;
}) {
  return (
    <Stack
      gap="16px"
      justifyContent="space-between"
      css={responsive({
        flexDirection: { base: "column", lg: "row" },
        padding: { base: "24px", lg: "52px 48px" },
        borderRadius: "16px",
      })}
      background={colors.gray100}
      overflow="hidden"
    >
      <VStack
        justifyContent={justifyContent || "center"}
        css={responsive({
          width: { base: "100%", lg: "50%" },
        })}
      >
        <Box className="orange650 subtitle_18_b lg_head_24_b">0{num}</Box>
        <Box
          className="gray900 head_24_b lg_head_32_b"
          css={responsive({
            whiteSpace: "pre-line",
            padding: { base: "8px 0 10px", lg: "16px 0 20px" },
          })}
        >
          {title}
        </Box>

        <Box
          className="gray600 body_14_r lg_subtitle_21_r"
          css={{ wordBreak: "keep-all" }}
        >
          {description}
        </Box>
      </VStack>
      <VStack borderRadius="16px" css={responsive(imageSize)}>
        <Image
          src={getCdnImageSrc(`b2b/disposal/benefit-2-${num}.png`)}
          width="100%"
          height="auto"
          alt=""
        />
      </VStack>
    </Stack>
  );
}
